import { render, staticRenderFns } from "./custom-token-form.vue?vue&type=template&id=7d3828ea&"
import script from "./custom-token-form.vue?vue&type=script&lang=ts&"
export * from "./custom-token-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports